module.exports = __webpack_public_path__ + "static/media/AndroidDevelopment.a3533196.JPG";